<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> {{ labels.filters }}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker
                            v-model="forms.ltaTranDate"
                            :label="labels.ltaTranDate"
                            :data-vv-as="labels.ltaTranDate"
                            data-vv-name="forms.ltaTranDate"
                            :error-messages="errors.collect('forms.ltaTranDate')"
                            v-validate="'required'"
                          ></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6> </v-flex>
                        <v-flex xs12 sm12 md12 lg12>
                          <v-text-field
                            v-model="forms.polNos"
                            :label="labels.polNos"
                            :error-messages="errors.collect('polNos')"
                            data-vv-name="polNos"
                            :data-vv-as="labels.polNos"
                            append-icon="mdi-magnify"
                            @click:append="getHelpList('polNos')"
                            v-validate="'required'"
                            readonly
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12 sm6 md6 lg6>
          <v-btn color="primary" dark :loading="processing" @click.prevent="doSubmit">
            {{ labels.unset }}
            <v-icon dark right>mdi-replay</v-icon>
          </v-btn>
          <!-- <v-btn-toggle dense mandatory v-model="forms.format">
            <v-btn text>
              <span>{{labels.format}}</span>
              <v-icon>mdi-clipboard-text</v-icon>
            </v-btn>
          </v-btn-toggle> -->
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="processing" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="polMtrRiskHelpList" width="900px" persistent>
      <multi-pol-mtr-risk-help-list
        v-if="polMtrRiskHelpList"
        :polno="forms.polNos"
        :ltaTranDate="forms.ltaTranDate"
        :apiUrl="polNoApiUrl"
        @close="doClose"
        @doAssign="doAssign($event)"
      ></multi-pol-mtr-risk-help-list>
    </v-dialog>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import MultiPolMtrRiskHelpList from '@/components/core/common/dialog/MultiPolMtrRiskHelpList'

export default {
  data() {
    return {
      labels: {
        filters: 'Filters',
        ltaTranDate: 'Transmitted to LTA on',
        polNos: 'Policy No.',
        unset: 'Unset Date'
      },
      forms: {
        ltaTranDate: new Date(),
        polNos: 'All'
      },
      processing: false,
      showErrorDialog: false,
      polMtrRiskHelpList: false,
      polNoApiUrl: undefined,
      panel1: [0]
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    async doInit() {
      // this.forms.tranDateTo = new Date()
    },
    doClose() {
      this.polMtrRiskHelpList = false
    },
    async doAssign(Obj) {
      this.forms.polNos = Obj.finalSelectedItems.toString()
    },
    getHelpList(data) {
      this.polMtrRiskHelpList = true
    },
    doSubmit() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doUnset()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUnset() {
      const apiUrl = this.$store.state.underwriting.dataTransferSettings.menu.unsetLTATranDate
      if (apiUrl) {
        try {
          this.processing = true
          await this.$http.post(apiUrl, this.forms)
          this.processing = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.processing = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url. [unsetLTATranDate]')
      }
    }
  },
  created() {
    this.polNoApiUrl = this.$store.state.underwriting.dataTransferSettings.menu.polMtrRiskList

    this.$validator.extend('ltaTranDate', {
      getMessage(field, args) {
        return 'LTA Transmission Date is required.'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var ltaTranDate = args[0]
        if (ltaTranDate === '' && ltaTranDate === undefined) {
          return false
        } else {
          return true
        }
      }
    })
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [MessageMixin],
  components: {
    MultiPolMtrRiskHelpList
  }
}
</script>

<style>
</style>
